import * as Sentry from "@sentry/react";

/**
 * Warns when a code-library payload contained undefined fields that were sanitized
 * before Firestore write (undefined → null). One grouped issue per field path so
 * repeat offenders are easy to find in Sentry.
 */
export const captureCodeLibUndefinedSanitized = ({
    fieldPath,
    undefinedPaths = [],
    uid,
    componentType,
    codeRef,
    user: { email, uid: userUid, name } = {},
}) => {
    const resolvedUid = uid || userUid;

    Sentry.withScope((scope) => {
        const sentryError = new Error(`Code library save sanitized undefined field: ${fieldPath}`);
        sentryError.name = "Code library undefined sanitized";

        scope.setFingerprint(["code-lib-undefined-sanitized", componentType || "unknown", fieldPath]);
        scope.setTag("code_lib_undefined_sanitized", true);
        scope.setTag("code_lib_operation", "save");
        scope.setTag("component_type", componentType);
        scope.setTag("code_lib_undefined_field", fieldPath);
        if (resolvedUid) {
            scope.setTag("uid", resolvedUid);
        }
        scope.setExtras({
            uid: resolvedUid,
            componentType,
            codeRef,
            fieldPath,
            undefinedPaths,
            undefinedPathCount: undefinedPaths.length,
        });
        scope.setTransactionName("Code library undefined sanitized");
        scope.setLevel("warning");
        scope.setUser({ email, uid: resolvedUid, name });

        scope.captureException(sentryError);
    });
};
